import {codexModes, emptyBrief, priorities, productAreas, requestTypes, sanitizeBrief} from "./product-brief-schema";

const requiredKeys = Object.keys(emptyBrief);
const technicalNoteKeys = Object.keys(emptyBrief.technicalNotes);
const requestTypeValues = requestTypes.map((item) => item.value);
const priorityValues = priorities.map((item) => item.value);
const codexModeValues = codexModes.map((item) => item.value);

export function parseProductBriefAiResponse(response) {
    const rawText = String(response?.data?.text || "");
    const jsonText = extractJsonObject(rawText);

    if (!jsonText) {
        return {success: false, errorKey: "pbb-ai-parse-invalid-json", rawText};
    }

    let parsed;
    try {
        parsed = JSON.parse(jsonText);
    } catch (error) {
        return {success: false, errorKey: "pbb-ai-parse-invalid-json", rawText};
    }

    const shapeError = validateBriefShape(parsed);
    if (shapeError) {
        return {success: false, errorKey: shapeError, rawText};
    }

    const normalized = {
        ...parsed,
        connectedAreas: parsed.connectedAreas.filter((area) => productAreas.includes(area)),
    };

    return {success: true, brief: sanitizeBrief(normalized), rawText};
}

function extractJsonObject(text) {
    const withoutFence = text
        .replace(/^```(?:json)?/i, "")
        .replace(/```$/i, "")
        .trim();

    const start = withoutFence.indexOf("{");
    const end = withoutFence.lastIndexOf("}");
    if (start === -1 || end === -1 || end <= start) return "";
    return withoutFence.slice(start, end + 1);
}

function validateBriefShape(value) {
    if (!value || typeof value !== "object" || Array.isArray(value)) return "pbb-ai-parse-invalid-schema";

    const hasAllKeys = requiredKeys.every((key) => Object.prototype.hasOwnProperty.call(value, key));
    if (!hasAllKeys) return "pbb-ai-parse-missing-keys";

    if (!requestTypeValues.includes(value.requestType)) return "pbb-ai-parse-invalid-enum";
    if (!priorityValues.includes(value.priority)) return "pbb-ai-parse-invalid-enum";
    if (!codexModeValues.includes(value.codexMode)) return "pbb-ai-parse-invalid-enum";

    if (!isStringList(value.userScenario)) return "pbb-ai-parse-invalid-schema";
    if (!isStringList(value.acceptanceCriteria)) return "pbb-ai-parse-invalid-schema";
    if (!Array.isArray(value.connectedAreas)) return "pbb-ai-parse-invalid-schema";
    if (!isStringList(value.outOfScope)) return "pbb-ai-parse-invalid-schema";
    if (!isStringList(value.openQuestions)) return "pbb-ai-parse-invalid-schema";
    if (!isRoleList(value.allowedRoles, ["role", "action", "description"])) return "pbb-ai-parse-invalid-schema";
    if (!isRoleList(value.deniedRoles, ["role", "limitation", "description"])) return "pbb-ai-parse-invalid-schema";

    if (!value.technicalNotes || typeof value.technicalNotes !== "object" || Array.isArray(value.technicalNotes)) {
        return "pbb-ai-parse-invalid-schema";
    }

    const hasAllTechnicalKeys = technicalNoteKeys.every((key) => Object.prototype.hasOwnProperty.call(value.technicalNotes, key));
    if (!hasAllTechnicalKeys) return "pbb-ai-parse-missing-keys";

    return "";
}

function isStringList(value) {
    return Array.isArray(value) && value.every((item) => typeof item === "string");
}

function isRoleList(value, keys) {
    return Array.isArray(value) && value.every((item) => {
        if (!item || typeof item !== "object" || Array.isArray(item)) return false;
        return keys.every((key) => Object.prototype.hasOwnProperty.call(item, key) && typeof item[key] === "string");
    });
}
